import { zIndex } from '@/features/world-map/utils/layer';
import { AdvancedMarker, useAdvancedMarkerRef } from '@vis.gl/react-google-maps';
import { useCallback, useEffect } from 'react';
import { ClusterSymbol } from './cluster-symbol';

/**
 * @typedef {object} ClusterMarkerClickEvent
 * @property {google.maps.marker.AdvancedMarkerElement} marker
 * @property {number | undefined} clusterId
 */

/**
 * @param {object} props
 * @param {number} [props.clusterId]
 * @param {string | number} [props.label]
 * @param {string} [props.ariaLabel]
 * @param {number} [props.size]
 * @param {google.maps.LatLngLiteral} props.position
 * @param {(event: ClusterMarkerClickEvent) => void} [props.onClick]
 * @returns {React.JSX.Element}
 */
export function ClusterMarker({ clusterId, label = '', ariaLabel = '', size = 40, position, onClick }) {
  const [markerRef, marker] = useAdvancedMarkerRef();

  const handleClick = useCallback(() => {
    if (!marker) {
      return;
    }

    onClick?.({ marker, clusterId });
  }, [clusterId, marker, onClick]);

  useEffect(() => {
    if (marker) {
      marker.ariaLabel = ariaLabel;
    }
  }, [marker, ariaLabel]);

  return (
    <AdvancedMarker
      ref={markerRef}
      style={{ lineHeight: 0 }}
      position={position}
      onClick={handleClick}
      zIndex={zIndex.cluster}
    >
      <ClusterSymbol size={size} label={label} />
    </AdvancedMarker>
  );
}
